import { ApiResponse, Landmark, ViewDaily } from "../types/api";
import { http } from "./http";

export const listLandmarks = async (): Promise<Landmark[]> => {
  const { data } = await http.get<ApiResponse<Landmark[]>>("/landmarks");
  if (!data.success || !data.data) throw new Error(data.error || "Load landmarks failed");
  return data.data;
};

export const getLandmark = async (id: number): Promise<Landmark> => {
  const { data } = await http.get<ApiResponse<Landmark>>(`/landmarks/${id}`);
  if (!data.success || !data.data) throw new Error(data.error || "Load landmark failed");
  return data.data;
};

export const createLandmark = async (
  landmark: Omit<Landmark, "id" | "station">
): Promise<Landmark> => {
  const { data } = await http.post<ApiResponse<Landmark>>("/landmarks", landmark);
  if (!data.success || !data.data) throw new Error(data.error || "Create landmark failed");
  return data.data;
};

export const updateLandmark = async (
  id: number,
  landmark: Partial<Omit<Landmark, "id">>
): Promise<Landmark> => {
  const { data } = await http.put<ApiResponse<Landmark>>(`/landmarks/${id}`, landmark);
  if (!data.success || !data.data) throw new Error(data.error || "Update landmark failed");
  return data.data;
};

export const deleteLandmark = async (id: number): Promise<void> => {
  const { data } = await http.delete<ApiResponse<null>>(`/landmarks/${id}`);
  if (!data.success) throw new Error(data.error || "Delete landmark failed");
};

export const getLandmarkViewsByDateRange = async (
  landmarkId: number,
  start: string, // YYYY-MM-DD
  end: string    // YYYY-MM-DD
): Promise<ViewDaily[]> => {
  const { data } = await http.get<ApiResponse<ViewDaily[]>>(
    `/view/${landmarkId}`,
    {
      params: {
        start,
        end,
      },
    }
  )

  if (!data.success || !data.data) {
    throw new Error(data.error || 'Load landmark views failed')
  }

  return data.data
}
